<template>

<div id="home">

  <Slide01/>

  <Slide02/>

  <Slide03/>

  <Slide04/>

</div>

</template>

<script>
import Slide01 from './home-slides/Slide01.vue'
import Slide02 from './home-slides/Slide02.vue'
import Slide03 from './home-slides/Slide03.vue'
import Slide04 from './home-slides/Slide04.vue'

export default {
  name: 'Home',
  components: {
    Slide01,
    Slide02,
    Slide03,
    Slide04
  }
}
</script>

<style lang="scss" scoped>
</style>
